module.exports = __webpack_public_path__ + "static/img/icon_breed_on.6f8a3f0e.svg";